<template>
  <v-row dense>
    <v-col cols="12" sm="6">
      <span class="caption font-weight-bold">Natureza</span>
      <div>
        {{ formData.NATUREZA | truncate(45) }}
      </div>
    </v-col>
    <v-col cols="12" sm="6">
    <span class="caption font-weight-bold">Tipo de operação</span>
    <div>
      {{ formData.OPERACAO | truncate(45) }}
    </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
